import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import API_ENDPOINTS from '../api/apiConfig';
import Toast from '../components/Toast';
import useToast from '../hooks/useToast';

function RequestCall() {
    useEffect(() => {
        document.querySelectorAll('.set-bg').forEach(el => {
            const bg = el.getAttribute('data-setbg');
            if (bg) el.style.backgroundImage = `url('/${bg}')`;
        });
    }, []);


    const loanTypes = [
        { value: 'personal', label: 'Personal Loan' },
        { value: 'business', label: 'Business Loan' },
        { value: 'loan_against_property', label: 'Loan Against Property' },
        { value: 'credit_card', label: 'Credit Card' },
        { value: 'balance_transfer', label: 'Balance Transfer / Top-Up' },
        { value: 'gold', label: 'Gold Loan' },
        { value: 'car', label: 'Car Loan' },
        { value: 'home', label: 'Home Loan' },
        { value: 'insurance', label: 'Insurance' },
    ];

    const { toast, showToast, hideToast } = useToast();
    const [callbackForm, setCallbackForm] = useState({ name: '', email: '', phone: '', service: '' });
    const [callbackLoading, setCallbackLoading] = useState(false);

    const handleCallbackChange = (e) => {
        setCallbackForm({ ...callbackForm, [e.target.name]: e.target.value });
    };

    const handleCallbackSubmit = async (e) => {
        e.preventDefault();
        setCallbackLoading(true);
        try {
            const response = await fetch(API_ENDPOINTS.CREATECALLBACKREQUEST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(callbackForm),
            });
            const data = await response.json();
            if (data.status) {
                showToast(data.message, 'success');
                setCallbackForm({ name: '', email: '', phone: '', service: '' });
            } else {
                showToast(data.message, 'error');
            }
        } catch (err) {
            showToast('Network error! Please try again.', 'error');
        } finally {
            setCallbackLoading(false);
        }
    };

    return (
        <>
            {/* Toast Notification */}
            <Toast message={toast.message} type={toast.type} onClose={hideToast} />

            {/* <!-- Call Section Begin --> */}
            {/* Call Section */}
            <section className="call spad set-bg" data-setbg="img/call-req.webp">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 col-md-6">
                            <div className="call__text">
                                <div className="section-title">
                                    <h2>Request A Call Back</h2>
                                    <p>Not sure which loan is right for you? Our financial experts are ready to guide you.</p>
                                </div>
                                <Link to="/contact">Contact Us</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 offset-lg-1 col-md-6">
                            <form className="call__form" onSubmit={handleCallbackSubmit}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Name"
                                            value={callbackForm.name}
                                            onChange={handleCallbackChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Email"
                                            value={callbackForm.email}
                                            onChange={handleCallbackChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <input
                                            type="tel"
                                            name="phone"
                                            placeholder="Phone"
                                            maxLength={15}
                                            value={callbackForm.phone}
                                            onChange={handleCallbackChange}
                                            required
                                        />
                                    </div>
                                    <div className="col-lg-6" style={{ position: 'relative' }}>
                                        <select
                                            name="service"
                                            value={callbackForm.service}
                                            onChange={handleCallbackChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 40px 12px 15px',
                                                border: '2px solid rgba(255,255,255,0.3)',
                                                borderRadius: '8px',
                                                fontSize: '15px',
                                                fontWeight: '500',
                                                color: callbackForm.service ? '#333' : '#999',
                                                backgroundColor: '#fff',
                                                appearance: 'none',
                                                cursor: 'pointer',
                                                outline: 'none',
                                            }}
                                        >
                                            <option value="" disabled>Choose a Service</option>
                                            {loanTypes.map(lt => (
                                                <option key={lt.value} value={lt.value}>{lt.label}</option>
                                            ))}
                                        </select>
                                        <span style={{
                                            position: 'absolute',
                                            right: '28px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            pointerEvents: 'none',
                                            color: '#7b5ea7',
                                            fontSize: '18px',
                                        }}>▾</span>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    className="site-btn"
                                    disabled={callbackLoading}
                                    style={{ opacity: callbackLoading ? 0.7 : 1, cursor: callbackLoading ? 'not-allowed' : 'pointer' }}
                                >
                                    {callbackLoading ? 'Submitting...' : 'Request Callback'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Call Section End --> */}
            
        </>
    );
}

export default RequestCall;